import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, ref } from 'vue';
import GstplnApp from '@/components/apps/app';
import { useRouter } from 'vue-router/composables';
import store from '@/store/store';
import App from '@/grpc-api/model/app';
import { actionShowError } from '@/services/vue-utils';
import i18n from '@/plugins/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppCard',
  props: {
  app: { type: Object as PropType<GstplnApp>, required: true },
},
  setup(__props, { expose }) {

const props = __props;

const router = useRouter();



const loading = ref(false);

const installing = ref(false);

const uninstalling = ref(false);

const configDialogVisible = ref(false);

const configDialogParams = ref('');

const configScreenComponent = computed(() => `${props.app.configComponent()}`);

const configuring = computed(() => configDialogVisible.value);

const installed = computed(() => props.app.installed);

const categories = computed(() => props.app.categories.map((c) => i18n.tc(`code.app_category.${c}`)));

const uninstall = async () => {
  try {
    uninstalling.value = true;
    loading.value = true;
    await store.dispatch('updateApp', { gstplnAppId: props.app.id, install: false });
  } catch (e: any) {
    actionShowError(e);
  } finally {
    loading.value = false;
    uninstalling.value = false;
  }
};

const configure = async () => {
  if (!props.app.configComponent()) return;

  props.app.loadConfigComponent();

  try {
    loading.value = true;
    const app = await store.dispatch('getApp', { gstplnAppId: props.app.id, install: true }) as App;
    configDialogParams.value = app.params ?? '';
    configDialogVisible.value = true;
  } catch (e: any) {
    actionShowError(e);
    installing.value = false; // install finish if called from install
  } finally {
    loading.value = false;
  }
};

const install = async () => {
  if (props.app.configComponent() && props.app.configBeforeInstall) {
    installing.value = true;
    configure();
    return;
  }

  try {
    loading.value = true;
    const app = await store.dispatch('updateApp', { gstplnAppId: props.app.id, install: true });
    configDialogParams.value = app.params ?? '';
  } catch (e: any) {
    console.log('install error: ', e);
    actionShowError(e);
  } finally {
    loading.value = false;
    installing.value = false;
  }
};

const closeConfigDialog = () => {
  console.log('closeConfigDialog');
  configDialogVisible.value = false;
  installing.value = false; // install finish if configure called from install
};

const saveConfigDialog = async (params?: string, close = true) => {
  try {
    loading.value = true;
    const app = await store.dispatch('updateApp', { gstplnAppId: props.app.id, install: true, params });
    configDialogParams.value = app.params ?? '';
    if (close) closeConfigDialog();
  } catch (e: any) {
    actionShowError(e);
  } finally {
    loading.value = false;
  }
  return configDialogParams.value;
};

const updateConfigDialog = async (params?: string) => saveConfigDialog(params, false);

const goToApp = async (force = false) => {
  if (!installed.value && !force) { return; }
  if (props.app.configComponent()) {
    configure();
    return;
  }
  router.push(props.app.appConfigRoute || props.app.url);
};

expose({ goToApp });


return { __sfc: true,router, props, loading, installing, uninstalling, configDialogVisible, configDialogParams, configScreenComponent, configuring, installed, categories, uninstall, configure, install, closeConfigDialog, saveConfigDialog, updateConfigDialog, goToApp }
}

})